import { render, staticRenderFns } from "./DepositPreliminary.vue?vue&type=template&id=ca28ae3a"
import script from "./DepositPreliminary.vue?vue&type=script&lang=js"
export * from "./DepositPreliminary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports